// extracted by mini-css-extract-plugin
module.exports = {"zonaPro":"\"Zona Pro\",Roboto,Arial,sans-serif"};